export class InhouseListModel {
  id: number;
  hotel_id: number;
  profile_id: number;
  full_name: string;
  title: string;
  first_name: string;
  last_name: string;
  voucher: string;
  tc_no: string;
  date_of_birth: Date;
  nationality: string;
  passport_no: string;
  mobile: string;
  email: string;
  proficiency: string;
  sex: string;
  rec_id: number;
  checkin_date: Date;
  check_out_date: Date;
  room_number: string;
  created_at: Date;
  updated_at: Date;
  status: string;
  note: string;
  agency_id: number;
  agency_name: string;
  repeat: number;
  pax: number;
  market_code: string;
  channel: string;
  room_price: number;
  daily_room_price: number;
  reservation_id: number;

  constructor() {
    this.id  = 0;
    this.hotel_id  = 0;
    this.profile_id  = 0;
    this.full_name = '';
    this.title = '';
    this.first_name = '';
    this.last_name = '';
    this.voucher = '';
    this.tc_no = '';
    this.date_of_birth = new Date();
    this.nationality = '';
    this.passport_no = '';
    this.mobile = '';
    this.email = '';
    this.proficiency = '';
    this.sex = '';
    this.rec_id  = 0;
    this.checkin_date = new Date();
    this.check_out_date = new Date();
    this.room_number = '';
    this.created_at = new Date();
    this.updated_at = new Date();
    this.status = '';
    this.note = '';
    this.agency_id  = 0;
    this.agency_name = '';
    this.repeat  = 0;
    this.pax  = 0;
    this.market_code = '';
    this.channel = '';
    this.room_price  = 0;
    this.daily_room_price  = 0;
    this.reservation_id  = 0;
  }
}
